export default __webpack_public_path__ + "milan-b66382e3fccf23040d46751a03040a66.bundle.jpg";